function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(1, 1)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#005a83",
  d: "M 7.5019531 1 A 0.50005 0.50005 0 0 0 7.3027344 1.0410156 L 0.60546875 3.9101562 C 0.238877 4.0675517 0 4.4317448 0 4.8300781 L 0 5.5 A 0.50005 0.50005 0 0 0 0.5 6 L 3 6 L 3 5 L 1 5 L 1 4.8300781 L 7.5 2.0449219 L 14 4.8300781 L 14 5 L 12 5 L 12 6 L 14.5 6 A 0.50005 0.50005 0 0 0 15 5.5 L 15 4.8300781 C 15 4.4317448 14.761123 4.0675517 14.394531 3.9101562 L 7.6972656 1.0410156 A 0.50005 0.50005 0 0 0 7.5019531 1 z M 7.0117188 5 L 7.0117188 6 L 6.5 6 C 5.6774686 6 5 6.6774686 5 7.5 C 5 8.3225314 5.6774686 9 6.5 9 L 7.25 9 L 7.75 9 L 8.5 9 C 8.7814686 9 9 9.2185314 9 9.5 C 9 9.7814686 8.7814686 10 8.5 10 L 6.5 10 L 5 10 L 5 11 L 6.5 11 L 7.0117188 11 L 7.0117188 12 L 8.0117188 12 L 8.0117188 11 L 8.5 11 C 9.3225314 11 10 10.322531 10 9.5 C 10 8.6774686 9.3225314 8 8.5 8 L 7.75 8 L 7.25 8 L 6.5 8 C 6.2185314 8 6 7.7814686 6 7.5 C 6 7.2185314 6.2185314 7 6.5 7 L 9 7 L 9 6 L 8.0117188 6 L 8.0117188 5 L 7.0117188 5 z M 1 7 L 1 13 L 0 13 L 0 14 L 15 14 L 15 13 L 14 13 L 14 7 L 13 7 L 13 13 L 2 13 L 2 7 L 1 7 z",
  vectorEffect: "non-scaling-stroke"
}));

var SvgIcons8BankBuilding = function SvgIcons8BankBuilding(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 18 18",
    width: 24,
    height: 24,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcons8BankBuilding, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icons8-bank_building.84dc07d6.svg";
export { ForwardRef as ReactComponent };